import React from "react"
import PropTypes from "prop-types"
import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { isTestEnvironment } from "../utils/testing"

const whereHasImageData = (node) => !!node?.childImageSharp?.gatsbyImageData
const toName = (node) => node.name
const whereMatchesName = (name) => (node) => node.name === name

function StaticImage({ name, alt, className, objectPosition, loading }) {
  const result = useStaticQuery(graphql`
    {
      allFile(filter: { absolutePath: { regex: "//src/images/" } }) {
        nodes {
          name
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  `)

  const node = result?.allFile?.nodes
    .filter(whereHasImageData)
    .find(whereMatchesName(name))

  if (!node) {
    const allImageNames = result?.allFile?.nodes.map(toName).join(", ")
    if (!isTestEnvironment()) {
      // eslint-disable-next-line no-console
      console.warn(
        `No image called '${name}'. Please choose from ${allImageNames}`,
      )
    }

    return <></>
  }

  return (
    <GatsbyImage
      image={node.childImageSharp?.gatsbyImageData}
      alt={alt}
      className={className}
      imgStyle={{ objectPosition }}
      loading={loading}
    />
  )
}

StaticImage.propTypes = {
  name: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
  objectPosition: PropTypes.string,
  loading: PropTypes.string,
}

StaticImage.defaultProps = {
  alt: "",
  className: undefined,
  objectPosition: "center",
  loading: "lazy",
}

const StorybookMock = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <img src="https://www.fillmurray.com/g/200/100" alt="demo" {...props} />
)

// Use an entirely different image component in storybook because the graphql query can't be evaluated there
// and causes errors. This isn't ideal, hopefully we can find a better way in future
export default process.env.STORYBOOK_ENV ? StorybookMock : StaticImage
